exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.categoryList .v-list-item {\n    min-height: 32px !important;\n}\n.categoryPicker .v-select__selections {\n    flex-wrap: nowrap;\n}\n\n", ""]);
